var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{class:['pagination-total sm:mx-auto sm:w-auto', _vm.wrapperClass]},[_c('span',[_c('strong',{staticClass:"page-number"},[_vm._v(_vm._s(_vm.pagination.total)+" 件中")]),_vm._v(" "+_vm._s(_vm.pageElementStart)+"～"+_vm._s(_vm.pageElementEnd)+"件表示 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }